// extracted by mini-css-extract-plugin
export default {"classic":"PreHeader_classic__XOasu"};